import React from 'react'
import { Button, IconClose } from '@grammarly/badger-ui'
import { Text, Heading } from '@grammarly/design-system'
import { FormattedMessage, useIntl } from 'react-intl'

import { Card } from '../../section/go-templates-tool/card'
import { Modal } from '../../ui-lib/modal'
import { ButtonColor } from '@components/ui-lib/button'
import { SignUpModalContent } from '../../ui-lib/modal/signup'
import { SignUpProductRecButton } from '@components/item/cta-button/signup-product-recommendation'
import { useTool } from '../tool-context'

import goTemplatesStyles from '../../section/go-templates-tool/go-templates-tool.module.scss'
import styles from '../tool.module.scss'

interface ToolModalProps {
  isOpen: boolean
  onClose: () => void
}

// @todo Tools are only running on anonymous users for now. We need to add support for signed in users. Right now we are showing the same signup wall for all users (even signed in users)
export const ToolUsageModal: React.FC<ToolModalProps> = ({ isOpen, onClose }) => {
  const intl = useIntl()
  return (
    <Modal className={goTemplatesStyles.signupWallModal} isOpen={isOpen} onRequestClose={onClose}>
      <Card className={goTemplatesStyles.signupWall}>
        <Button
          className={goTemplatesStyles.signupWallClose}
          padding="none"
          onClick={onClose}
          aria-label={intl.formatMessage({
            id: 'global.uiAction.close',
            description: 'Text for CTA that closes an element',
            defaultMessage: 'Close',
          })}
        >
          <IconClose aria-hidden={true} />
        </Button>
        <SignUpModalContent />
      </Card>
    </Modal>
  )
}

export const ToolExitIntentModal: React.FC<ToolModalProps> = ({ isOpen, onClose }) => {
  const intl = useIntl()
  return (
    <Modal className={goTemplatesStyles.signupWallModal} isOpen={isOpen} onRequestClose={onClose}>
      <Card className={goTemplatesStyles.signupWall}>
        <Button
          className={goTemplatesStyles.signupWallClose}
          padding="none"
          onClick={onClose}
          aria-label={intl.formatMessage({
            id: 'global.uiAction.close',
            description: 'Text for CTA that closes an element',
            defaultMessage: 'Close',
          })}
        >
          <IconClose aria-hidden={true} />
        </Button>
        <SignUpModalContent />
      </Card>
    </Modal>
  )
}

export const ToolTextLimitModal: React.FC<ToolModalProps> = ({ isOpen, onClose }) => {
  const { maxWordLimit } = useTool()
  const intl = useIntl()

  return (
    <Modal className={goTemplatesStyles.signupWallModal} isOpen={isOpen} onRequestClose={onClose}>
      <Card className={goTemplatesStyles.signupWall}>
        <Button
          className={goTemplatesStyles.signupWallClose}
          padding="none"
          onClick={onClose}
          aria-label={intl.formatMessage({
            id: 'global.uiAction.close',
            description: 'Text for CTA that closes an element',
            defaultMessage: 'Close',
          })}
        >
          <IconClose aria-hidden={true} />
        </Button>

        <Heading variant="heading-small" as="h2">
          <FormattedMessage
            id="tool.modals.textLimitModal.heading"
            description="Tool - Modals - Text Limit Modal - Heading"
            defaultMessage="This text exceeds the word limit"
          />
        </Heading>
        <Text variant="text-medium" as="p">
          <FormattedMessage
            id="tool.modals.textLimitModal.copy"
            description="Tool - Modals - Text Limit Modal - Copy"
            defaultMessage="There is a {maxWordLimit} word limit for this tool. Create a free account to use Grammarly with longer text."
            values={{ maxWordLimit }}
          />
        </Text>
        <SignUpProductRecButton
          color={ButtonColor.WDK24PrimaryLightBg}
          className={styles.toolTextLimitModalContent}
          text={
            <>
              <strong>
                <FormattedMessage id="phrase.getGrammarly" description="Get Grammarly" defaultMessage="Get Grammarly" />
              </strong>
              &nbsp;
              <FormattedMessage
                id="phrase.itsFree"
                description="Sign up prompt value prop"
                defaultMessage="It's free"
              />
            </>
          }
          showArrow
          placement="Modal"
          toQueryParam="editor"
        />
      </Card>
    </Modal>
  )
}
